import React, { useEffect } from "react";
import getPictureUrl from "../../../../lib/getPictureUrl";
import moment from "moment";

const NewsDetailPopup = ({ newItem, handleClosePopup }) => {
  const pictures = [{ url: newItem.image }];
  useEffect(() => {
    const popup = document.getElementById("popup-bg");
    if (popup) {
      popup.addEventListener("click", () => handleClosePopup(null), false);
    }
    return () => {
      popup.removeEventListener("click", () => handleClosePopup(null), false);
    };
  }, []);
  return (
    <div>
      <div className="modal-bg" id="popup-bg" />
      <div className="modal">
        <div className="sign-page">
          {/* Header */}
          <div className="head-general with-back">
            <a />
            <h4>News #{newItem.id}</h4>
            <a onClick={handleClosePopup} className="close cursor-pointer">
              <icon className="icon icon-close" />
            </a>
          </div>
          {/* Header */}
          <div className="modal-body">
            <React.Fragment key={newItem.id}>
              <div className="accordion-tab white-bg">
                <div className="item">
                  <div className="item accordion-button">
                    {newItem.image && (
                      <div className={`img ${(newItem.isRead && "") || "new"}`}>
                        {!newItem.isRead && <span className="badge">New</span>}

                        <img
                          align="left"
                          src={getPictureUrl(pictures, 600, 0)}
                        />
                      </div>
                    )}

                    {(newItem.image && (
                      <>
                        <div>
                          <h4>{newItem.title}</h4>
                          {!newItem.isRead && !newItem.image ? (
                            <span className="badge">New</span>
                          ) : (
                            <noscript />
                          )}

                          <div className="desc">
                            {(newItem.content && <p>{newItem.content}</p>) ||
                              null}
                          </div>
                        </div>
                      </>
                    )) || (
                      <>
                        <div>
                          <h4>{newItem.title}</h4>
                          {!newItem.isRead && !newItem.image ? (
                            <span className="badge">New</span>
                          ) : (
                            <noscript />
                          )}
                        </div>
                        <div className={"body accordion-panel"}>
                          <p>{newItem.content}</p>
                        </div>
                      </>
                    )}
                    <div className="foot d-flex align-items-center justify-content-between">
                      <p>{moment(newItem.createdAt).format("DD-MM-YYYY")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          </div>
          {/* .modal-body */}
        </div>{" "}
        {/* .sign-page */}
      </div>{" "}
      {/* .modal */}
    </div>
  );
};

export default NewsDetailPopup;
